module.exports = __webpack_public_path__ + "static/media/Item_Row_Purple@3x.8ef9c997.png";